import { useEffect } from 'react';
import h from '../helpers/common';

/** Back/Forward changes the URL language without the toggle, so bring the stored one in line */
const useUrlLanguageSync = (language: string) => {
    useEffect(() => {
        if (h.getLang() === language) {
            return;
        }
        h.switchLang(language);
        document.dispatchEvent(new Event('languageSwitched'));
    }, [language]);
};

export default useUrlLanguageSync;
